import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=69dbfb2a&lang=pug&"
import script from "./CustomIcon.vue?vue&type=script&lang=ts&"
export * from "./CustomIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=69dbfb2a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports